export enum BulkAddProductUIMessages {
  ID = '',
  Status = 'Please add a Status',
  Type = 'Please add a Type',
  Make = 'Please add a Make',
  Model = 'Please add a model',
  AssetType = 'Please add an Asset Type',
  RequiresAudit = 'Please indicate if Audit is required',
  LineOfService1 = 'Please add a line of service',
  LineOfService2 = '',
  LineOfService3 = '',
  LineOfService4 = '',
  LineOfService5 = ''
}
